<template>
  <div class="course-detail" v-show="courseDetail">
    <AudioDetail
      v-if="this.$route.query.courseIndex ?
        (courseDetail.subCourses &&
        courseDetail.subCourses[Number(this.$route.query.courseIndex)] &&
        courseDetail.subCourses[Number(this.$route.query.courseIndex)]
          .audioType == 1) : courseDetail.audioType == 1
      "
      :switchPlayingStatusType="switchPlayingStatusType"
      :handleAudioPlay="handleAudioPlay"
      :monitorAudioEnded="monitorAudioEnded"
      :playingStatusType="playingStatusType"
      :audioState="audioState"
      :audioList="audioList"
      :atSelectAudio="atSelectAudio"
      :switchAudio="switchAudio"
      :answerChapter="answerChapter"
    />
    <VideoDetail
      v-if="
      this.$route.query.courseIndex ?
        courseDetail.subCourses &&
        courseDetail.subCourses[Number(this.$route.query.courseIndex)] &&
        courseDetail.subCourses[Number(this.$route.query.courseIndex)]
          .audioType == 2 : courseDetail.audioType == 2
      "
      :videoList="videoList"
      :atSelectVideo="atSelectVideo"
      :switchVideo="switchVideo"
    />
  </div>
</template>

<script>
import module from "../../../modules/mediaCourse";
import { mapState, mapMutations } from "vuex";
import keys from "lodash.keys";
import AudioDetail from "./components/AudioDetail";
import VideoDetail from "./components/VideoDetail";
import queryString from "@/utils/queryString";
import api from "@edu-fe/api";

export default {
  data() {
    return {
      audioState: false,
      playingStatusType: 1, // 1 顺序播放   2  列表循环  3  单曲循环
      audioList: [],
      atSelectAudio: "",
      currentAudioIndex: 0,

      videoList: [],
      currentVideoIndex: 0,
      atSelectVideo: "",
    };
  },

  computed: {
    ...mapState(module.name, keys(module.state)),
  },

  mounted() {
    if (queryString().orgMediaInfoId) {
      this.init();
      this.currentAudioIndex = 0;
    }
    this.handleAudioPlay(false);
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    async init() {
      this.$loading.show();
      let params = {
        orgMediaInfoId: queryString().orgMediaInfoId,
      };
      const { data } = await api.mediaCourse.getCourseDetail(params)();
      this.$loading.hide();
      if (data) {
        this.saveCourseDetail(data);
        this.disposeAudioList();
      }
    },
    handleAudioPlay(value) {
      this.audioState = value;
    },

    disposeAudioList() {
      if (!this.courseDetail) {
        return this.$toast.show({
          message: `暂无数据`,
        });
      }
      if (this.courseDetail.mediaLevel == 1) {
        let modelData = this.courseDetail.subCourses;
        if (!modelData[Number(this.$route.query.courseIndex)]) {
          return this.$toast.show({
            message: `暂无数据`,
          });
        }
        if (modelData[Number(this.$route.query.courseIndex)].audioType == 1) {
          let tempData =
            modelData[Number(this.$route.query.courseIndex)].mediaItemList;
          // atSelectAudio
          if (!tempData[0]) {
            return this.$toast.show({
              message: `暂无数据`,
            });
          }

          tempData.forEach((item, index) => {
            item["audioUrl"] = item.audioUrl + "#" + new Date().getTime();
            item["index"] = index;
          });

          this.atSelectAudio = tempData[0];

          this.audioList = tempData;
        }

        if (modelData[Number(this.$route.query.courseIndex)].audioType == 2) {
          let tempData =
            modelData[Number(this.$route.query.courseIndex)].mediaItemList;
          if (!tempData[0]) {
            return this.$toast.show({
              message: `暂无数据`,
            });
          }
          tempData.forEach((item, index) => {
            item["audioUrl"] = item.audioUrl + "#" + new Date().getTime();
            item["index"] = index;
          });
          this.atSelectVideo = tempData[0];
          this.videoList = tempData;
        }
      }

      if (this.courseDetail.mediaLevel == 2) {
        let modelData = this.courseDetail
        if (modelData.audioType == 1) {
          let tempData = modelData.mediaItemList;
          // atSelectAudio
          if (!tempData[0]) {
            return this.$toast.show({
              message: `暂无数据`,
            });
          }

          tempData.forEach((item, index) => {
            item["audioUrl"] = item.audioUrl + "#" + new Date().getTime();
            item["index"] = index;
          });

          this.atSelectAudio = tempData[0];

          this.audioList = tempData;
        }

        if (modelData.audioType == 2) {
          let tempData = modelData.mediaItemList;
          if (!tempData[0]) {
            return this.$toast.show({
              message: `暂无数据`,
            });
          }
          tempData.forEach((item, index) => {
            item["audioUrl"] = item.audioUrl + "#" + new Date().getTime();
            item["index"] = index;
          });
          this.atSelectVideo = tempData[0];
          this.videoList = tempData;
        }
      }
    },

    switchPlayingStatusType() {
      if (this.playingStatusType == 3) {
        this.playingStatusType = 1;
      } else {
        this.playingStatusType++;
      }

      switch (this.playingStatusType) {
        case 1:
          this.$toast.show({
            message: `顺序播放切换成功`,
          });
          break;
        case 2:
          this.$toast.show({
            message: `列表循环切换成功`,
          });
          break;
        case 3:
          this.$toast.show({
            message: `单曲循环切换成功`,
          });
          break;
      }
    },

    switchAudio(item, index) {
      let tempResult = {
        index,
        ...item,
      };
      tempResult["audioUrl"] = tempResult.audioUrl + "#" + new Date().getTime();
      this.atSelectAudio = tempResult;
      this.$forceUpdate();
      this.currentAudioIndex = index;
    },

    switchVideo(item, index) {
      let tempResult = {
        index,
        ...item,
      };
      tempResult["audioUrl"] = tempResult.audioUrl + "#" + new Date().getTime();
      this.atSelectVideo = tempResult;
      this.$forceUpdate();
    },

    monitorAudioEnded() {
      switch (this.playingStatusType) {
        case 1:
          if (this.audioList[this.currentAudioIndex + 1]) {
            this.currentAudioIndex++;
            this.switchAudioItem();
          }
          break;
        case 2:
          if (!this.audioList[this.currentAudioIndex + 1]) {
            this.currentAudioIndex = 0;
            this.switchAudioItem();
          } else {
            this.currentAudioIndex++;
            this.switchAudioItem();
          }
          break;
      }
    },

    answerChapter(flag) {
      if (flag) {
        if (this.audioList[this.currentAudioIndex + 1]) {
          this.currentAudioIndex++;
          this.switchAudioItem();
        } else {
          this.currentAudioIndex = 0;
          this.switchAudioItem();
        }
      } else {
        if (this.audioList[this.currentAudioIndex - 1]) {
          this.currentAudioIndex--;
          this.switchAudioItem();
        } else {
          this.currentAudioIndex = this.audioList.length - 1;
          this.switchAudioItem();
        }
      }
    },

    switchAudioItem() {
      let tempResult = {
        index: this.currentAudioIndex,
        ...this.audioList[this.currentAudioIndex],
      };
      tempResult["audioUrl"] = tempResult.audioUrl + "#" + new Date().getTime();
      this.atSelectAudio = tempResult;
    },
  },

  components: {
    AudioDetail,
    VideoDetail,
  },
};
</script>

<style lang="scss" scoped>
</style>